<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <mask :id="id">
        <rect x="0" y="0" width="100%" height="100%" fill="white" />
        <rect
          v-if="stop"
          width="5.293"
          height="27.447"
          transform="translate(19.86 0.44) rotate(45)"
          fill="#000"
          stroke-miterlimit="10"
          stroke-width="1"
        />
      </mask>
    </defs>
    <path
      :mask="stop ? `url(#${id})` : ''"
      d="M6.1,10.7A17.15,17.15,0,0,0,13.4,18l2.4-2.4a1.13,1.13,0,0,1,1.1-.3,12.91,12.91,0,0,0,3.9.6A1.11,1.11,0,0,1,21.9,17v3.9A1.11,1.11,0,0,1,20.8,22,18.78,18.78,0,0,1,2,3.24v0A1.11,1.11,0,0,1,3.1,2.1H7A1.11,1.11,0,0,1,8.1,3.2a12.31,12.31,0,0,0,.6,3.9,1.13,1.13,0,0,1-.3,1.1Z"
    />
    <rect
      v-if="stop"
      width="2.3"
      height="24.4"
      transform="translate(19.815 2.54) rotate(45)"
      fill="#c40000"
      stroke-miterlimit="10"
      stroke-width="1"
    />
  </svg>
</template>

<script>
export default {
  name: 'TelIcon',
  props: {
    /** 赤い斜線を表示します */
    stop: Boolean,
  },
  computed: {
    id() {
      return `diagonalLine_${Math.random()
        .toString(36)
        .slice(-8)}`
    },
  },
}
</script>
